import { default as default2 } from "./icon";
export * from "./library";
export {
  default2 as Icon
};
//# sourceMappingURL=index.js.map
